import React, { FC } from 'react';
import colors from '@packages/core/styles/colors';
import { Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { DetailViewAside } from '../../components/detail-view/detail-view-aside';

const useDetailViewAsideStyles = createUseStyles({
    aside: {
        borderRight: `1px solid ${colors.grayThree}`,
        width: 248,
    },
});

const styles = StyleSheet.create({
    typographyStyles: {
        fontWeight: '700',
        color: '#4C525D',
        lineHeight: 15.95,
    },
});

export const CvtLeftAside: FC = () => {
    const classes = useDetailViewAsideStyles();
    const { t } = useTranslation();

    return (
        <DetailViewAside classNames={classes.aside}>
            <Typography variant="caption2" style={styles.typographyStyles}>
                CVT Diagnostic
            </Typography>
        </DetailViewAside>
    );
};
